import Alpine from 'alpinejs';

export default new class Header {
  constructor() {
    this.init();
  }

  init() {
    Alpine.store();
  }
}